/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import Accesspage from './../../common/404';
import Counsellor_Profile from '../Counselling/profile';
import Manager_Dashboard from '../Dashboard';
import Add_User from './../../modules/settings/User/Add-User';
import Add_Role from './../../modules/settings/Role/Add-Role';
import Role_List from './../../modules/settings/Role/Role-List';
import Idle_TAT_Report from '../Reports/Idle-TAT-Report';
import TAT_Report from '../Reports/Tat-Report';
import User_List from './../../modules/settings/User/User-List';
import Privilege_Create from './../../modules/settings/Privilege/Privilege-Create';
import User_Doctor_Map from './../../modules/settings/User/User-to-Doctor-Map';
import User_Details from './../../modules/settings/User/User-Details';
import Edit_User_Details from './User/Edit-User';
import Configuration from './Configurations';
import { userList } from '../../schema/user';
import BlockedUsers from './BlockedUsers';
class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            "showAdd": false,
            "showEdit": false,
            "showView": false,
        };
    }
    componentDidMount() {
        // this.renderPermission();
    }
    renderbodyLayer() {
        const { id, slug } = this.props.match.params
        const { menuList } = this.props;
        let showAdd = false;
        let showEdit = false;
        let showView = false;
        // let obj = null;
        // menuList.map(data => {
        //     var subData = data
        //         .submenu
        //         .find(o => o.route === slug);
        //     console.log(subData);
        //     if (subData != undefined) {
        //         obj = subData;
        //     }
        // })


        menuList.map((menu) => {
            if (slug !== undefined && slug !== null && slug !== '') {

                if (menu['route'] === id) {
                    menu['submenu'].map((smenu) => {
                        if (slug === 'add-user' || slug === 'edit-user' || slug === 'view-user') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'users') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }
                        if (slug === 'add-counselling-stations' || slug === 'edit-counselling-stations' || slug === 'view-counselling-stations') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'counselling-stations') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }
                        if (slug === 'add-doctor' ||slug === 'edit-doctor' || slug === 'view-doctor') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'doctors') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }

                        if (slug === 'add-role' ||slug === 'edit-role' || slug === 'view-role') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'roles') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }

                        if(slug === 'edit-privilege') {
                            menu['submenu'].map((smenu) => {
                            showEdit = JSON.parse(smenu['permissions']['edit']);
                            });
                        }

                        if (smenu['route'] === slug) {
                            showView = JSON.parse(smenu['permissions']['view']);
                            showAdd = JSON.parse(smenu['permissions']['add']);
                            showEdit = JSON.parse(smenu['permissions']['edit']);
                        }
                    })
                }
            }

            if (slug === undefined && id !== undefined) {
                if (menu['route'] === id) {
                    showView = JSON.parse(menu['permissions']['view']);
                    showAdd = JSON.parse(menu['permissions']['add']);
                    showEdit = JSON.parse(menu['permissions']['edit']);
                }
            }
        })



        var page = null;
        // if (obj !== undefined) {
            switch (slug) {
                case 'counselling-stations':
                case 'users':
                case 'doctors':
                case 'roles':
                    if (showView) {
                        page = <User_List {...this.props} menuList={menuList} />;
                    } else {
                        page = <Accesspage></Accesspage>;
                    }
                    break;
                case 'add-user':
                case 'add-doctor':
                case 'add-counselling-stations':
                    if (showAdd) {
                        page = <Add_User {...this.props} menuList={menuList} />;
                    } else {
                        page = <Accesspage></Accesspage>;
                    }
                    break;
                case 'edit-user':
                case 'edit-doctor':
                case 'edit-counselling-stations':   
                case 'edit-privilege':               
                    console.log(showEdit);
                    if (showEdit) {
                        page = <Add_User {...this.props} menuList={menuList} />;
                    } else {
                        page = <Accesspage></Accesspage>;
                    }
                    break;
                case 'view-user':
                case 'view-doctor':
                    page = <User_Details {...this.props} menuList={menuList} />;
                    break;
                // case 'roles':
                //     page = <User_List {...this.props} menuList={menuList} />;
                //     break;
                case 'add-role':
                    if (showAdd) {
                        page = <Add_Role {...this.props} menuList={menuList} />;
                    } else {
                        page = <Accesspage></Accesspage>;
                    }

                    break;
                case 'view-role':
                    if (showView) {
                        page = <Add_Role {...this.props} menuList={menuList} />;
                    } else {
                        page = <Accesspage></Accesspage>;
                    }
                    break;
                case 'edit-role':
                    if (showEdit) {
                        page = <Add_Role {...this.props} menuList={menuList} />;
                    } else {
                        page = <Accesspage></Accesspage>;
                    }
                    break;

                case 'privileges':
                    page = <Privilege_Create {...this.props} menuList={menuList} />;
                    break;
                case 'user-doctor-mapping':
                    page = <User_Doctor_Map {...this.props} menuList={menuList} />;
                    break;
                case 'configurations':
                    page = <Configuration {...this.props} menuList={menuList} />;
                    break;
                case 'blocked_users':
                    page = <BlockedUsers {...this.props} menuList={menuList} />;
                    break;
                default:
                    let submenu = null;
                    page = <Accesspage></Accesspage>;
                    // if (menuList[0]['submenu'].length !== 0) {
                    //     submenu = menuList[0]['submenu'][0]['route']
                    // }
                    // if (submenu !== null) {
                    //     this
                    //         .props
                    //         .history
                    //         .push(`/${menuList[0]['route']}/${submenu}`);
                    // } else {
                    //     this
                    //         .props
                    //         .history
                    //         .push(`/${menuList[0]['route']}}`);
                    // }
                    break;
            }
        // } else {
        //     page = <Accesspage></Accesspage>;
        // }
       
      
        return page;
    }

   
    render() {

        return (
            <div>
                {this.renderbodyLayer()}
            </div>
        );
    }
}

export default Settings;
